import type { ComponentChildren } from 'preact'
import styles from './banner.module.css'

interface BannerProps {
  readonly children: ComponentChildren
  readonly action?: ComponentChildren
}

/** A one-line notice or a restart prompt. Announced when it appears. */
export function Banner({ children, action }: BannerProps) {
  return (
    <div class={styles.banner} role="status">
      <p class={styles.text}>{children}</p>
      {action}
    </div>
  )
}
